import { render, staticRenderFns } from "./SuccessScreen.vue?vue&type=template&id=3f7b689f&scoped=true"
import script from "./SuccessScreen.vue?vue&type=script&lang=js"
export * from "./SuccessScreen.vue?vue&type=script&lang=js"
import style0 from "./SuccessScreen.vue?vue&type=style&index=0&id=3f7b689f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7b689f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f7b689f')) {
      api.createRecord('3f7b689f', component.options)
    } else {
      api.reload('3f7b689f', component.options)
    }
    module.hot.accept("./SuccessScreen.vue?vue&type=template&id=3f7b689f&scoped=true", function () {
      api.rerender('3f7b689f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PurchaseFlow/SuccessScreen.vue"
export default component.exports